const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
  },

  header: {
    userNameText: 'Hi,',
    logoutText: 'Logout',
    selectedCompanyEmail: 'Selected company:',
  },

  singleFileUploader: {
    attachFiles: 'Attach Files',
  },

  fileUploaderIsolated: {
    errorMessages: {
      sameFileTypeUpload: 'Sorry, all uploaded files must have the same type',
      notSupportedTypeUpload: 'Sorry, this type of file is not supported',
      fileAlreadyUploaded: "Sorry, you can't upload same file twice",
      oneFileTypeUpload(type) {
        return `Sorry, you can upload only one ${type}`;
      },
      fileUploadCountLimit(limit) {
        return `You've reached the maximum limit (${limit})`;
      },
      fileUploadSizeLimit(limit) {
        return `You've reached the maximum limit (${limit} MB)`;
      },
    },
  },
};

export default commonStrings;
